<template>
  <div
    id="filter-habilitation-modal"
    class="modal fade filter-habilitation-modal"
    data-backdrop="static"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content modal-borderless">
        <div class="modal-header">
          <h4 class="modal-title"></h4>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click.stop.prevent="hideModal"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label for="legal">
                  {{$t('form.dlv')}} {{ $t('startDate') }} / {{ $t('endDate') }}
                </label>
                <date-picker
                  v-model="dlvRange"
                  :lang="locale"
                  :format="$t('dateFormat')"
                  value-type="YYYY-MM-DD"
                  name="date"
                  class="form-control form-control_date"
                  id="dlv-dates"
                  range
                ></date-picker>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label for="legal">{{ $t('validityFilter') }} </label>
                <date-picker
                  v-model="dateRange"
                  :lang="locale"
                  :format="$t('dateFormat')"
                  value-type="YYYY-MM-DD"
                  name="date"
                  class="form-control form-control_date"
                  id="session-dates"
                  range
                ></date-picker>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label for="legal">{{ $t('qualif') }} </label>
                <treeselect
                  v-model="qualif"
                  :multiple="false"
                  :options="optionsQualifs"
                  :placeholder="$t('qualif')"
                  :normalizer="normalizer"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label for="legal">{{ $t('category') }} </label>
                <treeselect
                  v-model="category"
                  :multiple="false"
                  :options="optionsCategories"
                  :placeholder="$t('category')"
                  :normalizer="normalizerCategory"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="isIata"
                  v-model="isIata"
                />
                <label for="isIata" class="custom-control-label">{{
                  $t('iata')
                }}</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="ext"
                  v-model="ext"
                />
                <label for="ext" class="custom-control-label">{{
                  $t('ext')
                }}</label>
              </div>
            </div>
          </div>
          <div class="modal-footer d-flex flex-wrap justify-content-between p-0">
            <div>
              <div v-if="monitor.visible" :class="monitor.type">
                {{ monitor.message }}
              </div>
            </div>
            <button
              @click.prevent.stop="filter"
              class="btn btn-primary d-flex align-items-center"
              :disabled="isLoading"
            >
              <div
                class="spinner-border spinner-border-sm mr-2"
                role="status"
                v-if="isLoading"
              >
                <span class="sr-only"></span>
              </div>
              {{ $t('filter') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { lazyInput } from 'vue-lazy-input'
import { mapFields } from 'vuex-map-fields'
import DatePicker from 'vue2-datepicker'
export default {
  name: 'FilterModal',
  directives: {
    lazyInput,
  },
  components: { DatePicker, Treeselect },
  data() {
    return {
      normalizer(node) {
        return {
          id: node.id,
          label: node.title,
        }
      },
      normalizerCategory(node) {
        return {
          id: node.code,
          label: node.code,
        }
      },
      isIata: null,
      ext: null,
      locale: '',
      qualif: null,
      category: null,
      showAlert: false,
      dlvRange: [],
      dateRange: [],
      optionsQualifs: [],
      optionsCategories: [],
      isLoading: false,
      monitor: {
        visible: false,
        message: '',
        type: 'text-danger',
      },
    }
  },
  watch: {
    $route: {
      handler(to, from) {
        if (this.$lodash.get(this.$route, 'query', false)) {
          if (this.$route.query.startDateDlv &&this.$route.query?.endDateDlv) {
            this.dlvRange.push(this.$route.query?.startDateDlv)
            this.dlvRange.push(this.$route.query?.endDateDlv)
          }
          if (this.$route.query?.startDate && this.$route.query?.endDate) {
            this.dateRange.push(this.$route.query?.startDate)
            this.dateRange.push(this.$route.query?.endDate)
          }
          if (this.$route.query?.iata) {
            this.isIata = this.$route.query?.iata
          }
          if (this.$route.query?.ext) {
            this.ext = this.$route.query?.ext
          }
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapFields(['user']),
    filterData() {
      let arr = []
      if (this.dateRange.length) {
        arr.push(this.dateRange.length)
      }
      if (this.dlvRange.length) {
        arr.push(this.dlvRange.length)
      }
      if (this.isIata) {
        arr.push(this.isIata)
      }
      if (this.ext) {
        arr.push(this.ext)
      }
      if (this.qualif) {
        arr.push(this.qualif)
      }
      if (this.category) {
        arr.push(this.category)
      }
      return arr
    },
  },

  mounted() {
    this.locale = document.head.querySelector('meta[name="app-locale"]').content
    this.getQualifsList()
    this.getCategoriesList()
    this.$bus.$on('filter-habilitation-modal.show', () => {
      console.log('qualifsList ', this.qualifsList)
      $('#filter-habilitation-modal').modal('show')
    })
    this.$bus.$on('hide-filter-habilitation-modal', () => {
      this.isLoading = false
      $('#filter-habilitation-modal').modal('hide')
    })
    this.$bus.$on('error-filter-habilitation-modal', (err) => {
      console.log('err ', err)
      this.isLoading = false
        this.monitor.type = 'text-danger'
      this.monitor.message = this.$t('errors.serverError')
      this.monitor.visible = true
      setTimeout(() => {
        this.monitorHide()
      }, 2000)
    })

    this.$bus.$on('reset-filter-habilitations', () => {
      console.log('reset-filter-habilitations')
      this.isIata = null
      this.ext = null
      this.dlvRange = []
      this.dateRange = []
      this.qualif = null
      this.category = null
    })
  },
  methods: {
    getQualifsList() {
      this.$store.dispatch('habilitations/getQualifsList').then((resp) => {
        this.optionsQualifs = resp.sort((a, b) => {
          if (a && b) {
            return a?.title.localeCompare(b?.title)
          }
        })
      })
    },
    getCategoriesList() {
      this.$store.dispatch('habilitations/getCategoriesList').then((resp) => {
        this.optionsCategories = resp.sort((a, b) => {
          if (a && b) {
            return a?.code.localeCompare(b?.code)
          }
        })
      })
    },
    hideModal() {
      $('#filter-habilitation-modal.show').modal('hide')
    },
    filter() {
      let data = {
        startDate:
          this.dateRange && this.dateRange.length ? this.dateRange[0] : null,
        endDate:
          this.dateRange && this.dateRange.length ? this.dateRange[1] : null,
        startDateDlv: this.dlvRange && this.dlvRange ? this.dlvRange[0] : null,
        endDateDlv: this.dlvRange && this.dlvRange ? this.dlvRange[1] : null,
        iata: this.isIata,
        habilitationId: this.qualif,
        category: this.category,
        ext: this.ext,
        sort: '-issue_date',
        page: 1,
        limit: 15,
      }
      console.log('data filter params ', { data, filterData: this.filterData })
      this.$bus.$emit('filter-habilitations', {
        data,
        filterData: this.filterData,
      })
      this.isLoading = true
    },
    monitorHide() {
      this.monitor.type = ''
      this.monitor.message = ''
      this.monitor.visible = false
    },
  },
}
</script>

<style></style>
